export default {"src":"/_next/static/media/Nerve and Muscle Disorders-1.7b026b06.svg","height":51,"width":51,"blurWidth":0,"blurHeight":0};